import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Divider,
    Grid,
    TextField,
    Button,
    CardHeader,
    CircularProgress,
    Link,
} from "@mui/material";
import { PageBar } from "../../CommonComponents";
import UploadFiles from "./UploadFiles";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import GoogleSheetsIcon from "@mui/icons-material/Google";
const base = "https://api.more.in/v1";

const Index = () => {
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState("");

    const handleGenerateTemplate = async () => {
        try {
            setLoading(true);
            const response = await axios.post(
                base +
                "/pricing",
                {
                    rawPath: "generate_pricing_approval_sheet",
                },
                {
                    headers: {
                        authorization: Cookies.get("ssp_sso_token"),
                        "content-type": "application/json",
                    },
                }
            );
            if (response?.data?.statusCode !== 200) {
                toast.error(response?.data?.body?.message || "Something went wrong", {
                    position: "top-right",
                });
                setLoading(false);
            } else if (response?.data?.statusCode === 200) {
                toast.success("File downloaded successfully", {
                    position: "top-right",
                });
                window.open(response?.data?.body?.url, "_blank");
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            toast.error("Something went wrong", { position: "top-right" });
        }
    };

    const handleCreateOffer = async () => {
        if (url == "" || url.trim() === "") {
            toast.error("Google sheet url is required", { position: "top-right" });
            return;
        }
        try {
            setLoading(true);
            const response = await axios.post(
                base +
                "/pricing",
                {
                    url: url,
                    rawPath: "save_pricing_approval",
                },
                {
                    headers: {
                        authorization: Cookies.get("ssp_sso_token"),
                        "content-type": "application/json",
                    },
                }
            );
            if (response?.data?.statusCode !== 200) {
                setLoading(false);
                toast.error(
                    response?.data?.body?.message ||
                    "Something went wrong please try again later",
                    { position: "top-right" }
                );
            } else if (response?.data?.statusCode === 200) {
                toast.success(
                    response?.data?.body?.message || "File uploaded successfully",
                    {
                        position: "top-right",
                    }
                );
                setTimeout(() => {
                    setLoading(false);
                    window.location.reload();
                }, 1500);
            }
        } catch (err) {
            setLoading(false);
            toast.error("Something went Wrong!!", { position: "top-right" });
        }
    };

    return (
        <>
            <Box>
                {loading && (
                    <Box
                        sx={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999,
                        }}
                    >
                        <CircularProgress color="primary" size={60} />
                        <Typography
                            variant="h6"
                            sx={{ color: "#fff", mt: 2, fontWeight: 500 }}
                        >
                            Loading...
                        </Typography>
                    </Box>
                )}
                <PageBar text="Pricing Approval" />
                <Box
                    sx={{
                        backgroundColor: "#fff",
                        borderRadius: 2,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        border: "1px solid #E0E0E0",
                        p: 3,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 3,
                        width: "90%",
                        mx: "auto",
                        marginTop: 3,
                    }}
                >
                    {/* Google Sheets Section */}
                    <Box sx={{ flex: 1, marginLeft: "30%" }}>
                        {/* Header with Icon */}
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <GoogleSheetsIcon sx={{ mr: 1, color: "#34A853" }} />
                            <Typography variant="h6">Google Sheets</Typography>
                        </Box>

                        {/* Warning Text */}
                        <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                            * Please make sure you have logged into gmail using moreretail’s
                            official email address.
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            <strong>Step 1 :</strong> Click on below link to generate pricing approval sheet:
                        </Typography>
                        <Link
                            href="#"
                            underline="always"
                            sx={{ display: "block", mb: 2, color: "#1976D2" }}
                            onClick={handleGenerateTemplate}
                        >
                            Generate Prcing Approval Sheet
                        </Link>

                        <Typography variant="body1" sx={{ mb: 1 }}>
                            <strong>Step 2 :</strong> Please paste below your above google
                            sheet url (after filling with data) :
                        </Typography>
                        <TextField
                            placeholder="paste your google sheet url here"
                            fullWidth
                            variant="outlined"
                            size="small"
                            onChange={(e) => setUrl(e.target.value)}
                            sx={{
                                mb: 2,
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: 1,
                                    "& fieldset": {
                                        borderColor: "#E0E0E0",
                                    },
                                },
                                width: "50%",
                            }}
                        />

                        <Typography variant="body1" sx={{ mb: 1 }}>
                            <strong>Step 3 :</strong> Press below button to initiate the
                            process :
                        </Typography>
                        <Button
                            variant="outlined"
                            startIcon={<GoogleSheetsIcon />}
                            sx={{
                                mt: 1,
                                borderColor: "#E0E0E0",
                                color: "#000",
                                textTransform: "none",
                            }}
                            style={{ backgroundColor: "#E0E0E0", color: "#000" }}
                            onClick={handleCreateOffer}
                        >
                            Save Data
                        </Button>
                    </Box>
                </Box>
                <UploadFiles />
            </Box>
        </>
    );
};

export default Index;
